const DEFAULT_CATEGORY_MULTIPLIERS = {
  A: [
    {hp_from: 0, hp_to: 20, price: 1},
    {hp_from: 21, hp_to: 35, price: 2},
    {hp_from: 36, hp_to: 999999, price: 5}
  ],
  B: [
    {hp_from: 0, hp_to: 99, price: 2.5},
    {hp_from: 100, hp_to: 149, price: 3.5},
    {hp_from: 150, hp_to: 199, price: 5},
    {hp_from: 200, hp_to: 249, price: 7.5},
    {hp_from: 250, hp_to: 999999, price: 15}
  ],
  C: [
    {hp_from: 0, hp_to: 200, price: 5},
    {hp_from: 201, hp_to: 999999, price: 10}
  ],
  D: [
    {hp_from: 0, hp_to: 200, price: 5},
    {hp_from: 201, hp_to: 999999, price: 10}
  ]
}
const getSuggestedMultiplier = (mulipliers, horsePowers) => {
  let suggestedHPMultiplier = 0
  mulipliers.forEach((item) => {
    if (horsePowers >= item.hp_from) {
      suggestedHPMultiplier = item.price
    }
  })
  return suggestedHPMultiplier
}
export default {
  namespaced: true,
  state: () => ({
    baseMultiplier: {},
    loading: true
  }),
  getters: {
    getBaseMultiplier: state => (regionId, car_categoryId, horsePowers) => {
      const hpMultipliers = state.baseMultiplier[+regionId]?.[car_categoryId]
      if (hpMultipliers && hpMultipliers.length) {
        return getSuggestedMultiplier(hpMultipliers, horsePowers)
      } else {
        return getSuggestedMultiplier(DEFAULT_CATEGORY_MULTIPLIERS[car_categoryId], horsePowers)
      }
    },
    isLoading: (state) => state.loading
  },
  actions: {
    async fetchBaseMultiplier({commit}) {
      commit('setLoading', true)
      const baseMultiplier = await this.$api.$get('helper/transport-tax-hp-multiplier', { requireToken: false })
      commit('setBaseMultiplier', baseMultiplier)
      commit('setLoading', false)
    }
  },
  mutations: {
    setBaseMultiplier(state, payload) {
      state.baseMultiplier = payload
    },
    setLoading(state, val) {
      state.loading = val
    }
  }
}
